/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigurationValidationRequest,
  ConflictResolutionRequest,
  IntegrationDeploymentRequest,
  IntegrationReconfigurationRequest,
  IntegrationUndeploymentRequest,
  IntegrationUpgradeRequest,
  OutboundConfigUpdateRequest,
  OutboundSyncRequest,
  OutboundSyncResponse,
  UpdateInstanceIngestionFilterRequest,
  UpdateIntegrationInstanceConfigurationRequest,
} from '../models/index';
import {
    ConfigurationValidationRequestFromJSON,
    ConfigurationValidationRequestToJSON,
    ConflictResolutionRequestFromJSON,
    ConflictResolutionRequestToJSON,
    IntegrationDeploymentRequestFromJSON,
    IntegrationDeploymentRequestToJSON,
    IntegrationReconfigurationRequestFromJSON,
    IntegrationReconfigurationRequestToJSON,
    IntegrationUndeploymentRequestFromJSON,
    IntegrationUndeploymentRequestToJSON,
    IntegrationUpgradeRequestFromJSON,
    IntegrationUpgradeRequestToJSON,
    OutboundConfigUpdateRequestFromJSON,
    OutboundConfigUpdateRequestToJSON,
    OutboundSyncRequestFromJSON,
    OutboundSyncRequestToJSON,
    OutboundSyncResponseFromJSON,
    OutboundSyncResponseToJSON,
    UpdateInstanceIngestionFilterRequestFromJSON,
    UpdateInstanceIngestionFilterRequestToJSON,
    UpdateIntegrationInstanceConfigurationRequestFromJSON,
    UpdateIntegrationInstanceConfigurationRequestToJSON,
} from '../models/index';

export interface CheckSchemaChangesRequest {
    instanceId: string;
    sessionId?: string;
}

export interface CheckUpgradeCompatibilityRequest {
    instanceId: string;
    targetVersionId: string;
    sessionId?: string;
}

export interface CloneInstanceRequest {
    instanceId: string;
    newInstanceName: string;
    sessionId?: string;
}

export interface DeployAnalyticsRuleRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface DeployAutomationRuleRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface DeployIntegrationRequest {
    integrationDeploymentRequest: IntegrationDeploymentRequest;
    tenantId?: string;
    sessionId?: string;
}

export interface DeployWorkbookRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface DisableInstanceRequest {
    instanceId: string;
    sessionId?: string;
}

export interface EnableInstanceRequest {
    instanceId: string;
    sessionId?: string;
}

export interface ExecuteIntegrationRequest {
    instanceId: string;
    sessionId?: string;
    requestBody?: { [key: string]: any; };
}

export interface GetInstanceRequest {
    instanceId: string;
    sessionId?: string;
}

export interface GetInstancesRequest {
    enabledOnly?: boolean;
    sessionId?: string;
}

export interface GetOutboundSyncSummaryRequest {
    instanceId: string;
    sessionId?: string;
}

export interface GetRunLimitsRequest {
    instanceId: string;
    sessionId?: string;
}

export interface GetSourceSchemaRequest {
    instanceId: string;
    sessionId?: string;
}

export interface GetStatistics1Request {
    instanceId: string;
    sessionId?: string;
}

export interface GetSyncConflictsRequest {
    instanceId: string;
    includeResolved?: boolean;
    sessionId?: string;
}

export interface GetSyncStatusRequest {
    instanceId: string;
    entityType: string;
    entityIds: Array<string>;
    sessionId?: string;
}

export interface GetUnhealthyInstancesRequest {
    sessionId?: string;
}

export interface HealthCheckRequest {
    instanceId: string;
    sessionId?: string;
}

export interface InstallIntegrationRequest {
    integrationId: string;
    versionId: string;
    instanceName: string;
    _configuration: string;
    tenantId?: string;
    sessionId?: string;
}

export interface LinkToScheduleRequest {
    instanceId: string;
    scheduleId: string;
    sessionId?: string;
}

export interface ReconfigureInstanceRequest {
    instanceId: string;
    integrationReconfigurationRequest: IntegrationReconfigurationRequest;
    sessionId?: string;
}

export interface RefreshSourceSchemaRequest {
    instanceId: string;
    sessionId?: string;
}

export interface ResolveConflictRequest {
    conflictId: string;
    conflictResolutionRequest: ConflictResolutionRequest;
    sessionId?: string;
}

export interface SyncOutboundRequest {
    instanceId: string;
    outboundSyncRequest: OutboundSyncRequest;
    sessionId?: string;
}

export interface SyncSentinelContentRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UndeployAnalyticsRuleRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UndeployAutomationRuleRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UndeployIntegrationRequest {
    integrationUndeploymentRequest: IntegrationUndeploymentRequest;
    sessionId?: string;
}

export interface UndeployWorkbookRequest {
    instanceId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UninstallIntegrationRequest {
    instanceId: string;
    sessionId?: string;
}

export interface UnlinkFromScheduleRequest {
    instanceId: string;
    sessionId?: string;
}

export interface UpdateIngestionFilterRequest {
    instanceId: string;
    updateInstanceIngestionFilterRequest: UpdateInstanceIngestionFilterRequest;
    sessionId?: string;
}

export interface UpdateInstanceConfigurationRequest {
    instanceId: string;
    updateIntegrationInstanceConfigurationRequest: UpdateIntegrationInstanceConfigurationRequest;
    sessionId?: string;
}

export interface UpdateOutboundConfigRequest {
    instanceId: string;
    outboundConfigUpdateRequest: OutboundConfigUpdateRequest;
    sessionId?: string;
}

export interface UpgradeInstanceRequest {
    instanceId: string;
    integrationUpgradeRequest: IntegrationUpgradeRequest;
    sessionId?: string;
}

export interface ValidateConfigurationRequest {
    configurationValidationRequest: ConfigurationValidationRequest;
    sessionId?: string;
}

/**
 * IntegrationsInstancesApi - interface
 * 
 * @export
 * @interface IntegrationsInstancesApiInterface
 */
export interface IntegrationsInstancesApiInterface {
    /**
     * Compares current source schema with stored schema and detects breaking changes
     * @summary Check for schema changes
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    checkSchemaChangesRaw(requestParameters: CheckSchemaChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Compares current source schema with stored schema and detects breaking changes
     * Check for schema changes
     */
    checkSchemaChanges(requestParameters: CheckSchemaChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Check if an instance can be upgraded to a target version
     * @summary Check upgrade compatibility
     * @param {string} instanceId Instance ID
     * @param {string} targetVersionId Target version ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    checkUpgradeCompatibilityRaw(requestParameters: CheckUpgradeCompatibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Check if an instance can be upgraded to a target version
     * Check upgrade compatibility
     */
    checkUpgradeCompatibility(requestParameters: CheckUpgradeCompatibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Create a copy of an existing integration instance
     * @summary Clone integration instance
     * @param {string} instanceId Source instance ID
     * @param {string} newInstanceName New instance name
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    cloneInstanceRaw(requestParameters: CloneInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a copy of an existing integration instance
     * Clone integration instance
     */
    cloneInstance(requestParameters: CloneInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Deploy analytics rule from Configuration Service to Sentinel workspace
     * @summary Deploy analytics rule
     * @param {string} instanceId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    deployAnalyticsRuleRaw(requestParameters: DeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Deploy analytics rule from Configuration Service to Sentinel workspace
     * Deploy analytics rule
     */
    deployAnalyticsRule(requestParameters: DeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Deploy automation rule from Configuration Service to Sentinel workspace
     * @summary Deploy automation rule
     * @param {string} instanceId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    deployAutomationRuleRaw(requestParameters: DeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Deploy automation rule from Configuration Service to Sentinel workspace
     * Deploy automation rule
     */
    deployAutomationRule(requestParameters: DeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Deploy an integration instance with configuration from the installation wizard
     * @summary Deploy integration
     * @param {IntegrationDeploymentRequest} integrationDeploymentRequest 
     * @param {string} [tenantId] Target tenant ID (optional, defaults to session tenant)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    deployIntegrationRaw(requestParameters: DeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Deploy an integration instance with configuration from the installation wizard
     * Deploy integration
     */
    deployIntegration(requestParameters: DeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Deploy workbook from Configuration Service to Sentinel workspace
     * @summary Deploy workbook
     * @param {string} instanceId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    deployWorkbookRaw(requestParameters: DeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Deploy workbook from Configuration Service to Sentinel workspace
     * Deploy workbook
     */
    deployWorkbook(requestParameters: DeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Disable an integration instance to stop processing
     * @summary Disable instance
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    disableInstanceRaw(requestParameters: DisableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disable an integration instance to stop processing
     * Disable instance
     */
    disableInstance(requestParameters: DisableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enable an integration instance to start processing
     * @summary Enable instance
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    enableInstanceRaw(requestParameters: EnableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enable an integration instance to start processing
     * Enable instance
     */
    enableInstance(requestParameters: EnableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Manually trigger inbound integration execution (fetch from external system) with optional execution parameters
     * @summary Execute integration manually
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {{ [key: string]: any; }} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    executeIntegrationRaw(requestParameters: ExecuteIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Manually trigger inbound integration execution (fetch from external system) with optional execution parameters
     * Execute integration manually
     */
    executeIntegration(requestParameters: ExecuteIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get detailed information about an integration instance
     * @summary Get instance by ID
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getInstanceRaw(requestParameters: GetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get detailed information about an integration instance
     * Get instance by ID
     */
    getInstance(requestParameters: GetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all integration instances for the selected tenants. When multiple tenants are selected in the session, returns instances from all selected tenants.
     * @summary Get all instances
     * @param {boolean} [enabledOnly] Only enabled instances
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getInstancesRaw(requestParameters: GetInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all integration instances for the selected tenants. When multiple tenants are selected in the session, returns instances from all selected tenants.
     * Get all instances
     */
    getInstances(requestParameters: GetInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Aggregated outbound sync state for an integration instance (Slice 19.UI.1)
     * @summary Get outbound sync summary
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getOutboundSyncSummaryRaw(requestParameters: GetOutboundSyncSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Aggregated outbound sync state for an integration instance (Slice 19.UI.1)
     * Get outbound sync summary
     */
    getOutboundSyncSummary(requestParameters: GetOutboundSyncSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get effective run limits and current running count for an integration instance
     * @summary Get run limits
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getRunLimitsRaw(requestParameters: GetRunLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get effective run limits and current running count for an integration instance
     * Get run limits
     */
    getRunLimits(requestParameters: GetRunLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Returns the cached source schema for the integration instance
     * @summary Get stored source schema
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getSourceSchemaRaw(requestParameters: GetSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Returns the cached source schema for the integration instance
     * Get stored source schema
     */
    getSourceSchema(requestParameters: GetSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get execution statistics for an integration instance
     * @summary Get instance statistics
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getStatistics1Raw(requestParameters: GetStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get execution statistics for an integration instance
     * Get instance statistics
     */
    getStatistics1(requestParameters: GetStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get outbound sync conflicts for an integration instance
     * @summary Get sync conflicts
     * @param {string} instanceId Instance ID
     * @param {boolean} [includeResolved] Include resolved conflicts
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getSyncConflictsRaw(requestParameters: GetSyncConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get outbound sync conflicts for an integration instance
     * Get sync conflicts
     */
    getSyncConflicts(requestParameters: GetSyncConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get outbound sync status for specific entities
     * @summary Get sync status
     * @param {string} instanceId Instance ID
     * @param {string} entityType Entity type
     * @param {Array<string>} entityIds List of entity IDs
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getSyncStatusRaw(requestParameters: GetSyncStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get outbound sync status for specific entities
     * Get sync status
     */
    getSyncStatus(requestParameters: GetSyncStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Lists all unhealthy integration instances for the tenant
     * @summary Get unhealthy instances
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    getUnhealthyInstancesRaw(requestParameters: GetUnhealthyInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all unhealthy integration instances for the tenant
     * Get unhealthy instances
     */
    getUnhealthyInstances(requestParameters: GetUnhealthyInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Perform health check on an integration instance
     * @summary Health check
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    healthCheckRaw(requestParameters: HealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Perform health check on an integration instance
     * Health check
     */
    healthCheck(requestParameters: HealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Install a new integration instance for the tenant
     * @summary Install integration
     * @param {string} integrationId Integration catalog ID
     * @param {string} versionId Version ID to install
     * @param {string} instanceName Instance name
     * @param {string} _configuration Initial configuration (JSON)
     * @param {string} [tenantId] Target tenant ID (optional, defaults to session tenant)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    installIntegrationRaw(requestParameters: InstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Install a new integration instance for the tenant
     * Install integration
     */
    installIntegration(requestParameters: InstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Link integration instance to a schedule for automatic execution
     * @summary Link to schedule
     * @param {string} instanceId Instance ID
     * @param {string} scheduleId Schedule ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    linkToScheduleRaw(requestParameters: LinkToScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Link integration instance to a schedule for automatic execution
     * Link to schedule
     */
    linkToSchedule(requestParameters: LinkToScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update integration instance configuration using wizard schema
     * @summary Reconfigure integration instance
     * @param {string} instanceId Instance ID
     * @param {IntegrationReconfigurationRequest} integrationReconfigurationRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    reconfigureInstanceRaw(requestParameters: ReconfigureInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update integration instance configuration using wizard schema
     * Reconfigure integration instance
     */
    reconfigureInstance(requestParameters: ReconfigureInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Fetches sample data from the integration and updates the stored source schema
     * @summary Refresh source schema
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    refreshSourceSchemaRaw(requestParameters: RefreshSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Fetches sample data from the integration and updates the stored source schema
     * Refresh source schema
     */
    refreshSourceSchema(requestParameters: RefreshSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Manually resolve an outbound sync conflict
     * @summary Resolve sync conflict
     * @param {string} conflictId Conflict ID
     * @param {ConflictResolutionRequest} conflictResolutionRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    resolveConflictRaw(requestParameters: ResolveConflictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Manually resolve an outbound sync conflict
     * Resolve sync conflict
     */
    resolveConflict(requestParameters: ResolveConflictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Manually trigger outbound sync to push CyberWell data to external system
     * @summary Sync to external system
     * @param {string} instanceId Instance ID
     * @param {OutboundSyncRequest} outboundSyncRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    syncOutboundRaw(requestParameters: SyncOutboundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundSyncResponse>>;

    /**
     * Manually trigger outbound sync to push CyberWell data to external system
     * Sync to external system
     */
    syncOutbound(requestParameters: SyncOutboundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundSyncResponse>;

    /**
     * Sync content (analytics rules, automation rules, or workbooks) from Sentinel workspace into Configuration Service (Microsoft Sentinel instances only)
     * @summary Sync Sentinel content
     * @param {string} instanceId Instance ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    syncSentinelContentRaw(requestParameters: SyncSentinelContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Sync content (analytics rules, automation rules, or workbooks) from Sentinel workspace into Configuration Service (Microsoft Sentinel instances only)
     * Sync Sentinel content
     */
    syncSentinelContent(requestParameters: SyncSentinelContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Undeploy analytics rule from Sentinel workspace
     * @summary Undeploy analytics rule
     * @param {string} instanceId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    undeployAnalyticsRuleRaw(requestParameters: UndeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Undeploy analytics rule from Sentinel workspace
     * Undeploy analytics rule
     */
    undeployAnalyticsRule(requestParameters: UndeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Undeploy automation rule from Sentinel workspace
     * @summary Undeploy automation rule
     * @param {string} instanceId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    undeployAutomationRuleRaw(requestParameters: UndeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Undeploy automation rule from Sentinel workspace
     * Undeploy automation rule
     */
    undeployAutomationRule(requestParameters: UndeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Remove an integration instance and all associated data
     * @summary Undeploy integration instance
     * @param {IntegrationUndeploymentRequest} integrationUndeploymentRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    undeployIntegrationRaw(requestParameters: UndeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Remove an integration instance and all associated data
     * Undeploy integration instance
     */
    undeployIntegration(requestParameters: UndeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Undeploy workbook from Sentinel workspace
     * @summary Undeploy workbook
     * @param {string} instanceId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    undeployWorkbookRaw(requestParameters: UndeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Undeploy workbook from Sentinel workspace
     * Undeploy workbook
     */
    undeployWorkbook(requestParameters: UndeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Uninstall an integration instance
     * @summary Uninstall integration
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    uninstallIntegrationRaw(requestParameters: UninstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Uninstall an integration instance
     * Uninstall integration
     */
    uninstallIntegration(requestParameters: UninstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Remove schedule link to stop automatic execution
     * @summary Unlink from schedule
     * @param {string} instanceId Instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    unlinkFromScheduleRaw(requestParameters: UnlinkFromScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Remove schedule link to stop automatic execution
     * Unlink from schedule
     */
    unlinkFromSchedule(requestParameters: UnlinkFromScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Configure instance-level filter applied to raw records before transform
     * @summary Update ingestion filter
     * @param {string} instanceId 
     * @param {UpdateInstanceIngestionFilterRequest} updateInstanceIngestionFilterRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    updateIngestionFilterRaw(requestParameters: UpdateIngestionFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Configure instance-level filter applied to raw records before transform
     * Update ingestion filter
     */
    updateIngestionFilter(requestParameters: UpdateIngestionFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update integration instance configuration
     * @summary Update instance configuration
     * @param {string} instanceId Instance ID
     * @param {UpdateIntegrationInstanceConfigurationRequest} updateIntegrationInstanceConfigurationRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    updateInstanceConfigurationRaw(requestParameters: UpdateInstanceConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update integration instance configuration
     * Update instance configuration
     */
    updateInstanceConfiguration(requestParameters: UpdateInstanceConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update outbound_config JSON for bidirectional integrations (Slice 19.UI.3)
     * @summary Update outbound config
     * @param {string} instanceId Instance ID
     * @param {OutboundConfigUpdateRequest} outboundConfigUpdateRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    updateOutboundConfigRaw(requestParameters: UpdateOutboundConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update outbound_config JSON for bidirectional integrations (Slice 19.UI.3)
     * Update outbound config
     */
    updateOutboundConfig(requestParameters: UpdateOutboundConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Upgrade an integration instance to a newer version with compatibility checking
     * @summary Upgrade integration instance
     * @param {string} instanceId Instance ID
     * @param {IntegrationUpgradeRequest} integrationUpgradeRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    upgradeInstanceRaw(requestParameters: UpgradeInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Upgrade an integration instance to a newer version with compatibility checking
     * Upgrade integration instance
     */
    upgradeInstance(requestParameters: UpgradeInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Validate a configuration against the integration schema before deployment
     * @summary Validate integration configuration
     * @param {ConfigurationValidationRequest} configurationValidationRequest 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsInstancesApiInterface
     */
    validateConfigurationRaw(requestParameters: ValidateConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Validate a configuration against the integration schema before deployment
     * Validate integration configuration
     */
    validateConfiguration(requestParameters: ValidateConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationsInstancesApi extends runtime.BaseAPI implements IntegrationsInstancesApiInterface {

    /**
     * Compares current source schema with stored schema and detects breaking changes
     * Check for schema changes
     */
    async checkSchemaChangesRaw(requestParameters: CheckSchemaChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling checkSchemaChanges().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/source-schema/changes`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Compares current source schema with stored schema and detects breaking changes
     * Check for schema changes
     */
    async checkSchemaChanges(requestParameters: CheckSchemaChangesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.checkSchemaChangesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if an instance can be upgraded to a target version
     * Check upgrade compatibility
     */
    async checkUpgradeCompatibilityRaw(requestParameters: CheckUpgradeCompatibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling checkUpgradeCompatibility().'
            );
        }

        if (requestParameters['targetVersionId'] == null) {
            throw new runtime.RequiredError(
                'targetVersionId',
                'Required parameter "targetVersionId" was null or undefined when calling checkUpgradeCompatibility().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['targetVersionId'] != null) {
            queryParameters['targetVersionId'] = requestParameters['targetVersionId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/check-compatibility`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Check if an instance can be upgraded to a target version
     * Check upgrade compatibility
     */
    async checkUpgradeCompatibility(requestParameters: CheckUpgradeCompatibilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.checkUpgradeCompatibilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a copy of an existing integration instance
     * Clone integration instance
     */
    async cloneInstanceRaw(requestParameters: CloneInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling cloneInstance().'
            );
        }

        if (requestParameters['newInstanceName'] == null) {
            throw new runtime.RequiredError(
                'newInstanceName',
                'Required parameter "newInstanceName" was null or undefined when calling cloneInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['newInstanceName'] != null) {
            queryParameters['newInstanceName'] = requestParameters['newInstanceName'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/clone`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a copy of an existing integration instance
     * Clone integration instance
     */
    async cloneInstance(requestParameters: CloneInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.cloneInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deploy analytics rule from Configuration Service to Sentinel workspace
     * Deploy analytics rule
     */
    async deployAnalyticsRuleRaw(requestParameters: DeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling deployAnalyticsRule().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deployAnalyticsRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/deploy-analytics-rule`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deploy analytics rule from Configuration Service to Sentinel workspace
     * Deploy analytics rule
     */
    async deployAnalyticsRule(requestParameters: DeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deployAnalyticsRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deploy automation rule from Configuration Service to Sentinel workspace
     * Deploy automation rule
     */
    async deployAutomationRuleRaw(requestParameters: DeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling deployAutomationRule().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deployAutomationRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/deploy-automation-rule`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deploy automation rule from Configuration Service to Sentinel workspace
     * Deploy automation rule
     */
    async deployAutomationRule(requestParameters: DeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deployAutomationRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deploy an integration instance with configuration from the installation wizard
     * Deploy integration
     */
    async deployIntegrationRaw(requestParameters: DeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationDeploymentRequest'] == null) {
            throw new runtime.RequiredError(
                'integrationDeploymentRequest',
                'Required parameter "integrationDeploymentRequest" was null or undefined when calling deployIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/deploy`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationDeploymentRequestToJSON(requestParameters['integrationDeploymentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deploy an integration instance with configuration from the installation wizard
     * Deploy integration
     */
    async deployIntegration(requestParameters: DeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deployIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deploy workbook from Configuration Service to Sentinel workspace
     * Deploy workbook
     */
    async deployWorkbookRaw(requestParameters: DeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling deployWorkbook().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling deployWorkbook().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/deploy-workbook`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Deploy workbook from Configuration Service to Sentinel workspace
     * Deploy workbook
     */
    async deployWorkbook(requestParameters: DeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deployWorkbookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disable an integration instance to stop processing
     * Disable instance
     */
    async disableInstanceRaw(requestParameters: DisableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling disableInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/disable`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disable an integration instance to stop processing
     * Disable instance
     */
    async disableInstance(requestParameters: DisableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disableInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable an integration instance to start processing
     * Enable instance
     */
    async enableInstanceRaw(requestParameters: EnableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling enableInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/enable`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enable an integration instance to start processing
     * Enable instance
     */
    async enableInstance(requestParameters: EnableInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually trigger inbound integration execution (fetch from external system) with optional execution parameters
     * Execute integration manually
     */
    async executeIntegrationRaw(requestParameters: ExecuteIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling executeIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/execute`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Manually trigger inbound integration execution (fetch from external system) with optional execution parameters
     * Execute integration manually
     */
    async executeIntegration(requestParameters: ExecuteIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.executeIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed information about an integration instance
     * Get instance by ID
     */
    async getInstanceRaw(requestParameters: GetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get detailed information about an integration instance
     * Get instance by ID
     */
    async getInstance(requestParameters: GetInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all integration instances for the selected tenants. When multiple tenants are selected in the session, returns instances from all selected tenants.
     * Get all instances
     */
    async getInstancesRaw(requestParameters: GetInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['enabledOnly'] != null) {
            queryParameters['enabledOnly'] = requestParameters['enabledOnly'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all integration instances for the selected tenants. When multiple tenants are selected in the session, returns instances from all selected tenants.
     * Get all instances
     */
    async getInstances(requestParameters: GetInstancesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getInstancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregated outbound sync state for an integration instance (Slice 19.UI.1)
     * Get outbound sync summary
     */
    async getOutboundSyncSummaryRaw(requestParameters: GetOutboundSyncSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getOutboundSyncSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/outbound-sync/summary`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Aggregated outbound sync state for an integration instance (Slice 19.UI.1)
     * Get outbound sync summary
     */
    async getOutboundSyncSummary(requestParameters: GetOutboundSyncSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getOutboundSyncSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get effective run limits and current running count for an integration instance
     * Get run limits
     */
    async getRunLimitsRaw(requestParameters: GetRunLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getRunLimits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/run-limits`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get effective run limits and current running count for an integration instance
     * Get run limits
     */
    async getRunLimits(requestParameters: GetRunLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRunLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the cached source schema for the integration instance
     * Get stored source schema
     */
    async getSourceSchemaRaw(requestParameters: GetSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getSourceSchema().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/source-schema`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns the cached source schema for the integration instance
     * Get stored source schema
     */
    async getSourceSchema(requestParameters: GetSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSourceSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get execution statistics for an integration instance
     * Get instance statistics
     */
    async getStatistics1Raw(requestParameters: GetStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getStatistics1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/statistics`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get execution statistics for an integration instance
     * Get instance statistics
     */
    async getStatistics1(requestParameters: GetStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getStatistics1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get outbound sync conflicts for an integration instance
     * Get sync conflicts
     */
    async getSyncConflictsRaw(requestParameters: GetSyncConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getSyncConflicts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeResolved'] != null) {
            queryParameters['includeResolved'] = requestParameters['includeResolved'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/sync-conflicts`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get outbound sync conflicts for an integration instance
     * Get sync conflicts
     */
    async getSyncConflicts(requestParameters: GetSyncConflictsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSyncConflictsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get outbound sync status for specific entities
     * Get sync status
     */
    async getSyncStatusRaw(requestParameters: GetSyncStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getSyncStatus().'
            );
        }

        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getSyncStatus().'
            );
        }

        if (requestParameters['entityIds'] == null) {
            throw new runtime.RequiredError(
                'entityIds',
                'Required parameter "entityIds" was null or undefined when calling getSyncStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['entityType'] != null) {
            queryParameters['entityType'] = requestParameters['entityType'];
        }

        if (requestParameters['entityIds'] != null) {
            queryParameters['entityIds'] = requestParameters['entityIds'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/sync-status`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get outbound sync status for specific entities
     * Get sync status
     */
    async getSyncStatus(requestParameters: GetSyncStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getSyncStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all unhealthy integration instances for the tenant
     * Get unhealthy instances
     */
    async getUnhealthyInstancesRaw(requestParameters: GetUnhealthyInstancesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/unhealthy`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all unhealthy integration instances for the tenant
     * Get unhealthy instances
     */
    async getUnhealthyInstances(requestParameters: GetUnhealthyInstancesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUnhealthyInstancesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Perform health check on an integration instance
     * Health check
     */
    async healthCheckRaw(requestParameters: HealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling healthCheck().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/health`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Perform health check on an integration instance
     * Health check
     */
    async healthCheck(requestParameters: HealthCheckRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.healthCheckRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Install a new integration instance for the tenant
     * Install integration
     */
    async installIntegrationRaw(requestParameters: InstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationId'] == null) {
            throw new runtime.RequiredError(
                'integrationId',
                'Required parameter "integrationId" was null or undefined when calling installIntegration().'
            );
        }

        if (requestParameters['versionId'] == null) {
            throw new runtime.RequiredError(
                'versionId',
                'Required parameter "versionId" was null or undefined when calling installIntegration().'
            );
        }

        if (requestParameters['instanceName'] == null) {
            throw new runtime.RequiredError(
                'instanceName',
                'Required parameter "instanceName" was null or undefined when calling installIntegration().'
            );
        }

        if (requestParameters['_configuration'] == null) {
            throw new runtime.RequiredError(
                '_configuration',
                'Required parameter "_configuration" was null or undefined when calling installIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['integrationId'] != null) {
            queryParameters['integrationId'] = requestParameters['integrationId'];
        }

        if (requestParameters['versionId'] != null) {
            queryParameters['versionId'] = requestParameters['versionId'];
        }

        if (requestParameters['instanceName'] != null) {
            queryParameters['instanceName'] = requestParameters['instanceName'];
        }

        if (requestParameters['_configuration'] != null) {
            queryParameters['configuration'] = requestParameters['_configuration'];
        }

        if (requestParameters['tenantId'] != null) {
            queryParameters['tenantId'] = requestParameters['tenantId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/install`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Install a new integration instance for the tenant
     * Install integration
     */
    async installIntegration(requestParameters: InstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.installIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Link integration instance to a schedule for automatic execution
     * Link to schedule
     */
    async linkToScheduleRaw(requestParameters: LinkToScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling linkToSchedule().'
            );
        }

        if (requestParameters['scheduleId'] == null) {
            throw new runtime.RequiredError(
                'scheduleId',
                'Required parameter "scheduleId" was null or undefined when calling linkToSchedule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['scheduleId'] != null) {
            queryParameters['scheduleId'] = requestParameters['scheduleId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/schedule`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Link integration instance to a schedule for automatic execution
     * Link to schedule
     */
    async linkToSchedule(requestParameters: LinkToScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.linkToScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update integration instance configuration using wizard schema
     * Reconfigure integration instance
     */
    async reconfigureInstanceRaw(requestParameters: ReconfigureInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling reconfigureInstance().'
            );
        }

        if (requestParameters['integrationReconfigurationRequest'] == null) {
            throw new runtime.RequiredError(
                'integrationReconfigurationRequest',
                'Required parameter "integrationReconfigurationRequest" was null or undefined when calling reconfigureInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/reconfigure`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationReconfigurationRequestToJSON(requestParameters['integrationReconfigurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update integration instance configuration using wizard schema
     * Reconfigure integration instance
     */
    async reconfigureInstance(requestParameters: ReconfigureInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.reconfigureInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches sample data from the integration and updates the stored source schema
     * Refresh source schema
     */
    async refreshSourceSchemaRaw(requestParameters: RefreshSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling refreshSourceSchema().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/source-schema/refresh`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Fetches sample data from the integration and updates the stored source schema
     * Refresh source schema
     */
    async refreshSourceSchema(requestParameters: RefreshSourceSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.refreshSourceSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually resolve an outbound sync conflict
     * Resolve sync conflict
     */
    async resolveConflictRaw(requestParameters: ResolveConflictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['conflictId'] == null) {
            throw new runtime.RequiredError(
                'conflictId',
                'Required parameter "conflictId" was null or undefined when calling resolveConflict().'
            );
        }

        if (requestParameters['conflictResolutionRequest'] == null) {
            throw new runtime.RequiredError(
                'conflictResolutionRequest',
                'Required parameter "conflictResolutionRequest" was null or undefined when calling resolveConflict().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/sync-conflicts/{conflictId}/resolve`;
        urlPath = urlPath.replace(`{${"conflictId"}}`, encodeURIComponent(String(requestParameters['conflictId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConflictResolutionRequestToJSON(requestParameters['conflictResolutionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Manually resolve an outbound sync conflict
     * Resolve sync conflict
     */
    async resolveConflict(requestParameters: ResolveConflictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.resolveConflictRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually trigger outbound sync to push CyberWell data to external system
     * Sync to external system
     */
    async syncOutboundRaw(requestParameters: SyncOutboundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OutboundSyncResponse>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling syncOutbound().'
            );
        }

        if (requestParameters['outboundSyncRequest'] == null) {
            throw new runtime.RequiredError(
                'outboundSyncRequest',
                'Required parameter "outboundSyncRequest" was null or undefined when calling syncOutbound().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sync-outbound`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundSyncRequestToJSON(requestParameters['outboundSyncRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OutboundSyncResponseFromJSON(jsonValue));
    }

    /**
     * Manually trigger outbound sync to push CyberWell data to external system
     * Sync to external system
     */
    async syncOutbound(requestParameters: SyncOutboundRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OutboundSyncResponse> {
        const response = await this.syncOutboundRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sync content (analytics rules, automation rules, or workbooks) from Sentinel workspace into Configuration Service (Microsoft Sentinel instances only)
     * Sync Sentinel content
     */
    async syncSentinelContentRaw(requestParameters: SyncSentinelContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling syncSentinelContent().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling syncSentinelContent().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/content-sync`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Sync content (analytics rules, automation rules, or workbooks) from Sentinel workspace into Configuration Service (Microsoft Sentinel instances only)
     * Sync Sentinel content
     */
    async syncSentinelContent(requestParameters: SyncSentinelContentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.syncSentinelContentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undeploy analytics rule from Sentinel workspace
     * Undeploy analytics rule
     */
    async undeployAnalyticsRuleRaw(requestParameters: UndeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling undeployAnalyticsRule().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling undeployAnalyticsRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/undeploy-analytics-rule`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Undeploy analytics rule from Sentinel workspace
     * Undeploy analytics rule
     */
    async undeployAnalyticsRule(requestParameters: UndeployAnalyticsRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.undeployAnalyticsRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undeploy automation rule from Sentinel workspace
     * Undeploy automation rule
     */
    async undeployAutomationRuleRaw(requestParameters: UndeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling undeployAutomationRule().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling undeployAutomationRule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/undeploy-automation-rule`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Undeploy automation rule from Sentinel workspace
     * Undeploy automation rule
     */
    async undeployAutomationRule(requestParameters: UndeployAutomationRuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.undeployAutomationRuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove an integration instance and all associated data
     * Undeploy integration instance
     */
    async undeployIntegrationRaw(requestParameters: UndeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationUndeploymentRequest'] == null) {
            throw new runtime.RequiredError(
                'integrationUndeploymentRequest',
                'Required parameter "integrationUndeploymentRequest" was null or undefined when calling undeployIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/undeploy`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationUndeploymentRequestToJSON(requestParameters['integrationUndeploymentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Remove an integration instance and all associated data
     * Undeploy integration instance
     */
    async undeployIntegration(requestParameters: UndeployIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.undeployIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undeploy workbook from Sentinel workspace
     * Undeploy workbook
     */
    async undeployWorkbookRaw(requestParameters: UndeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling undeployWorkbook().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling undeployWorkbook().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/sentinel/undeploy-workbook`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Undeploy workbook from Sentinel workspace
     * Undeploy workbook
     */
    async undeployWorkbook(requestParameters: UndeployWorkbookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.undeployWorkbookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uninstall an integration instance
     * Uninstall integration
     */
    async uninstallIntegrationRaw(requestParameters: UninstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling uninstallIntegration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Uninstall an integration instance
     * Uninstall integration
     */
    async uninstallIntegration(requestParameters: UninstallIntegrationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.uninstallIntegrationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove schedule link to stop automatic execution
     * Unlink from schedule
     */
    async unlinkFromScheduleRaw(requestParameters: UnlinkFromScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling unlinkFromSchedule().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/instances/{instanceId}/schedule`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Remove schedule link to stop automatic execution
     * Unlink from schedule
     */
    async unlinkFromSchedule(requestParameters: UnlinkFromScheduleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.unlinkFromScheduleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Configure instance-level filter applied to raw records before transform
     * Update ingestion filter
     */
    async updateIngestionFilterRaw(requestParameters: UpdateIngestionFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling updateIngestionFilter().'
            );
        }

        if (requestParameters['updateInstanceIngestionFilterRequest'] == null) {
            throw new runtime.RequiredError(
                'updateInstanceIngestionFilterRequest',
                'Required parameter "updateInstanceIngestionFilterRequest" was null or undefined when calling updateIngestionFilter().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/ingestion-filter`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateInstanceIngestionFilterRequestToJSON(requestParameters['updateInstanceIngestionFilterRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Configure instance-level filter applied to raw records before transform
     * Update ingestion filter
     */
    async updateIngestionFilter(requestParameters: UpdateIngestionFilterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateIngestionFilterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update integration instance configuration
     * Update instance configuration
     */
    async updateInstanceConfigurationRaw(requestParameters: UpdateInstanceConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling updateInstanceConfiguration().'
            );
        }

        if (requestParameters['updateIntegrationInstanceConfigurationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIntegrationInstanceConfigurationRequest',
                'Required parameter "updateIntegrationInstanceConfigurationRequest" was null or undefined when calling updateInstanceConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/configuration`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIntegrationInstanceConfigurationRequestToJSON(requestParameters['updateIntegrationInstanceConfigurationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update integration instance configuration
     * Update instance configuration
     */
    async updateInstanceConfiguration(requestParameters: UpdateInstanceConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateInstanceConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update outbound_config JSON for bidirectional integrations (Slice 19.UI.3)
     * Update outbound config
     */
    async updateOutboundConfigRaw(requestParameters: UpdateOutboundConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling updateOutboundConfig().'
            );
        }

        if (requestParameters['outboundConfigUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'outboundConfigUpdateRequest',
                'Required parameter "outboundConfigUpdateRequest" was null or undefined when calling updateOutboundConfig().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/outbound-config`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: OutboundConfigUpdateRequestToJSON(requestParameters['outboundConfigUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update outbound_config JSON for bidirectional integrations (Slice 19.UI.3)
     * Update outbound config
     */
    async updateOutboundConfig(requestParameters: UpdateOutboundConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateOutboundConfigRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upgrade an integration instance to a newer version with compatibility checking
     * Upgrade integration instance
     */
    async upgradeInstanceRaw(requestParameters: UpgradeInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling upgradeInstance().'
            );
        }

        if (requestParameters['integrationUpgradeRequest'] == null) {
            throw new runtime.RequiredError(
                'integrationUpgradeRequest',
                'Required parameter "integrationUpgradeRequest" was null or undefined when calling upgradeInstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/{instanceId}/upgrade`;
        urlPath = urlPath.replace(`{${"instanceId"}}`, encodeURIComponent(String(requestParameters['instanceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationUpgradeRequestToJSON(requestParameters['integrationUpgradeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Upgrade an integration instance to a newer version with compatibility checking
     * Upgrade integration instance
     */
    async upgradeInstance(requestParameters: UpgradeInstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.upgradeInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validate a configuration against the integration schema before deployment
     * Validate integration configuration
     */
    async validateConfigurationRaw(requestParameters: ValidateConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['configurationValidationRequest'] == null) {
            throw new runtime.RequiredError(
                'configurationValidationRequest',
                'Required parameter "configurationValidationRequest" was null or undefined when calling validateConfiguration().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/integrations/instances/validate-configuration`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigurationValidationRequestToJSON(requestParameters['configurationValidationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Validate a configuration against the integration schema before deployment
     * Validate integration configuration
     */
    async validateConfiguration(requestParameters: ValidateConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.validateConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
